import { useCallback } from 'react'
import { useStandardTrack } from './use-standard-track'
import type { FormName } from './use-track-form-action'

type TrackFormStepViewedParams = {
  step: string
  type: string
  formName: FormName
  formAction?: 'step-viewed' | 'submitted'
} & Record<string, unknown>

export const useTrackFormStepViewed = () => {
  const track = useStandardTrack()

  return useCallback(
    ({ step, type, formName, formAction = 'step-viewed', ...rest }: TrackFormStepViewedParams) => {
      track('Form Action', {
        form_action: formAction,
        form_name: formName,
        step_name: step,
        step,
        type,
        ...rest,
      })
    },
    [track]
  )
}
